module.exports = __webpack_public_path__ + "static/img/medal.87b5afdc.png";